import { crmApiInstance } from './client.js';

export const productStockApi = {
  getAll:       (params = {})       => crmApiInstance.get('/product-stocks', { params }).then(r => r.data),
  getById:      (id)                => crmApiInstance.get(`/product-stocks/${id}`).then(r => r.data),
  create:       (payload)           => crmApiInstance.post('/product-stocks', payload).then(r => r.data),
  update:       (id, payload)       => crmApiInstance.put(`/product-stocks/${id}`, payload).then(r => r.data),
  delete:       (id)                => crmApiInstance.delete(`/product-stocks/${id}`).then(r => r.data),
  linkProduct:  (id, productId)     => crmApiInstance.post(`/product-stocks/${id}/products`, { product_id: productId }).then(r => r.data),
  unlinkProduct: (id, productId)    => crmApiInstance.delete(`/product-stocks/${id}/products/${productId}`).then(r => r.data),
};
